import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { END_USER_SHARED_PROGRAMMES_ROUTE } from '../../services/routes';
import { useGetSharedProgrammeQuery } from '../../app/smorgAppSyncGraphQLApi';
import { useCurrentProgrammeEnrollmentQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { SHARED_PROGRAMMES_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const MyDayProgrammeCompletedCard = ({
  cardBackgroundColor,
  primaryMainColor,
}) => {
  const navigate = useNavigate();

  const { data: currentProgrammeEnrollment } =
    useCurrentProgrammeEnrollmentQuery();

  const { data: sharedProgramme } = useGetSharedProgrammeQuery(
    currentProgrammeEnrollment?.sharedProgrammeID,
    {
      skip: !currentProgrammeEnrollment?.sharedProgrammeID,
      refetchOnMountOrArgChange: SHARED_PROGRAMMES_REFRESH_INTERVAL_SECONDS,
    },
  );

  return (
    <div
      className="my-day-card"
      style={{
        backgroundColor: cardBackgroundColor,
        color: 'white',
        width: '352px',
        margin: '8px 8px 8px 16px',
      }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          padding: '10px',
        }}>
        <div
          style={{
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: 24,
          }}>
          Congratulations!
        </div>
        <div style={{ marginBottom: 4 }}>
          <p style={{ margin: '4px 0 12px' }}>
            You&apos;ve completed the {sharedProgramme?.title} program.
          </p>
        </div>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div
          style={{
            fontWeight: 'bold',
            backgroundColor: primaryMainColor,
            padding: '16px 8px',
            borderRadius: 15,
            cursor: 'pointer',
          }}
          onClick={(ev) => {
            ev.preventDefault();
            navigate(END_USER_SHARED_PROGRAMMES_ROUTE);
          }}>
          Choose your next program
        </div>
      </div>
    </div>
  );
};

MyDayProgrammeCompletedCard.propTypes = {
  cardBackgroundColor: PropTypes.string.isRequired,
  primaryMainColor: PropTypes.string.isRequired,
};

export default MyDayProgrammeCompletedCard;
